window.addEventListener('load', () => {
  const dataLayerBtns = document.querySelectorAll(`[data-dl]`)

  if (dataLayerBtns.length > 0) {
    dataLayerBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault

        const eventName = btn.getAttribute('data-dl')

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: `webinar_${eventName}`,
        })

        // btn.click();
      })
    })
  }
})
